import { css } from 'linaria';

const globalOverlay = 1100;

export const TooltipClassName = css`
  & [role='tooltip'] {
    z-index: ${globalOverlay};
    padding: var(--space-100) 0;
    background: var(--background-primary);
    box-shadow: var(--box-shadow-m);
    transition: unset;
    pointer-events: unset;

    & div::before {
      background: var(--background-primary);
    }
  }
`;
